import {
  Modal as SharedModal,
  type ModalProps as SharedModalProps,
} from "@ridereserv/ui";
import { cn } from "@ridereserv/shared/utils";

export type ModalProps = SharedModalProps;

/**
 * Admin styling adapter for the shared accessible modal behavior.
 *
 * @param props - Shared modal props plus optional panel classes.
 * @param props.className - Additional admin dialog-panel classes.
 * @returns The shared modal with the admin panel treatment.
 */
export function Modal({
  className,
  ...props
}: ModalProps): React.ReactElement {
  return (
    <SharedModal
      {...props}
      className={cn("rounded-lg bg-surface p-6 shadow-xl", className)}
    />
  );
}
